module.exports = __webpack_public_path__ + "img/about_img.3ed2aa03.png";